<template>
  <div class="ui-button-wrapper" :class="btnType" @click="handleClick">
    <span>{{ btnText }}</span>
    <span class="count" v-show="count">{{ count }}</span>
  </div>
</template>

<script>
export default {
  name: "uiButton",
  props: {
    btnText: {
      type: String,
      default: ""
    },
    count: {
      type: [Number, String],
      default: ""
    },
    btnType: {
      type: String,
      default: "orange"
    }
  },
  methods: {
    handleClick(e) {
      this.$emit("click", e)
    }
  }
}
</script>

<style lang="scss" scoped>
.ui-button-wrapper {
  background: rgba(56, 155, 239, 0.1);
  border: 1px solid #389bee;
  border-radius: 0.21rem;
  height: 0.36rem;
  padding: 0 0.15rem;
  color: #389bee;
  position: relative;
  display: inline-block;
  font-family: PingFangSC-Regular;
  font-size: 0.22rem;
  letter-spacing: 0;
  &.orange {
    border-color: #ff9a17;
    columns: #ff9a17;
    color: #e98400;
    background: #fff2e1;
  }
  .count {
    height: 0.3rem;
    min-width: 0.3rem;
    border-radius: 0.15rem;
    background: #f31c1c;
    font-family: PingFang-SC-Bold;
    font-size: 0.22rem;
    color: #ffffff;
    line-height: 0.3rem;
    letter-spacing: 0;
    padding: 0 0.08rem;
    position: absolute;
    top: -0.15rem;
    right: -0.15rem;
  }
}
</style>
